import { ROUTES } from 'src/enums/Routes';

export enum CREDIT_SEGMENT {
  REDUCING_DEFORESTATION = 'REDUCING_DEFORESTATION',
  NATURE_BASED_CARBON_DIOXIDE_REMOVAL = 'NATURE_BASED_CARBON_DIOXIDE_REMOVAL',
  TECHNOLOGICAL_CARBON_DIOXIDE_REMOVAL = 'TECHNOLOGICAL_CARBON_DIOXIDE_REMOVAL',
  SUPERPOLLUTANT_ABATEMENT = 'SUPERPOLLUTANT_ABATEMENT',
  LOW_CARBON_FUELS = 'LOW_CARBON_FUELS',
}

const SEGMENT_ROUTE_MAP: Record<CREDIT_SEGMENT, ROUTES> = {
  [CREDIT_SEGMENT.REDUCING_DEFORESTATION]: ROUTES.CREDITS_SEGMENT_REDUCE_DEFORESTATION,
  [CREDIT_SEGMENT.NATURE_BASED_CARBON_DIOXIDE_REMOVAL]: ROUTES.CREDITS_SEGMENT_RESTORING_FORESTS,
  [CREDIT_SEGMENT.TECHNOLOGICAL_CARBON_DIOXIDE_REMOVAL]: ROUTES.CREDITS_SEGMENT_TECH_CARBON_REMOVAL,
  [CREDIT_SEGMENT.SUPERPOLLUTANT_ABATEMENT]: ROUTES.CREDITS_SEGMENT_SUPERPOLLUTANTS,
  [CREDIT_SEGMENT.LOW_CARBON_FUELS]: ROUTES.CREDITS_SEGMENT_LOWER_CARBON_FUELS,
};

export const getSegmentRoute = (segment?: string): string | undefined => SEGMENT_ROUTE_MAP[segment as CREDIT_SEGMENT];
